var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-fab-transition',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"href":"https://hacercurriculum.es/contacto","color":"primary","fab":"","bottom":"","right":"","fixed":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("fas fa-comments")])],1)]}}])},[_c('span',[_vm._v("Comparte tu opinión con nosotros")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }